import MenuIcon from '@mui/icons-material/Menu';
import { Hidden } from '@mui/material';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import GuestMenu from 'components/app-menu/anonymous';
import OpportunitiesMenu from 'components/app-menu/opportunities';
import LoggedInMenu from 'components/app-menu/signed-in';
import Link from 'components/link';
import AuthenticationModal from 'containers/authentication';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { LogoutSuccessfulMessage } from 'lang/en/Snackbars';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { animateScroll } from 'react-scroll';
import { getProxy, getUser } from 'state/selectors';
import { logUserOut } from 'state/slice/authentication';
import { APP_ROUTES, TRANSPARENT_HEADER_ROUTES } from 'utils/routing';
import style from './style.module.scss';

const MobileDrawerSide = 'left';

const SvgLogo = ({ theme }: { theme: HeaderTheme }) => (
  <svg
    id="PropelLogo"
    width="155"
    height="29"
    viewBox="0 0 155 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.02059 21.0181C6.19069 23.1863 12 29 12 29C12 29 13.5594 27.4197 15.3692 25.6181C14.3562 24.6068 8.05479 18.3152 6.84079 17.0988C5.51721 15.7726 4.69838 13.9393 4.69838 11.9141C4.69838 7.86761 7.96742 4.58728 12 4.58728C16.0325 4.58728 19.3016 7.86761 19.3016 11.9141C19.3016 12.6608 19.0286 14.5738 17.9659 15.8341C16.6707 17.3701 14.7568 18.3967 14.7568 18.3967L18.7485 22.3013C19.2847 21.7866 19.7575 21.3421 20.1184 21.0181C22.5743 18.8132 24 15.6084 24 12.0415C24 5.39115 18.6274 0 12 0C5.37258 0 0 5.39115 0 12.0415C0 15.376 1.83818 18.8376 4.02059 21.0181ZM14.5397 11.914C14.5397 13.3214 13.4027 14.4624 12 14.4624C10.5974 14.4624 9.46034 13.3214 9.46034 11.914C9.46034 10.5065 10.5974 9.36551 12 9.36551C13.4027 9.36551 14.5397 10.5065 14.5397 11.914Z"
      fill={theme === HeaderTheme.Transparent ? '#FFFFFF' : '#00AEFF'}
    />
    <path
      d="M42.572 15.372C43.164 15.372 43.68 15.3 44.12 15.156C44.56 15.004 44.924 14.792 45.212 14.52C45.508 14.24 45.728 13.904 45.872 13.512C46.016 13.112 46.088 12.668 46.088 12.18C46.088 11.716 46.016 11.296 45.872 10.92C45.728 10.544 45.512 10.224 45.224 9.96C44.936 9.696 44.572 9.496 44.132 9.36C43.692 9.216 43.172 9.144 42.572 9.144H40.16V15.372H42.572ZM42.572 6.648C43.732 6.648 44.736 6.784 45.584 7.056C46.432 7.328 47.132 7.708 47.684 8.196C48.236 8.684 48.644 9.268 48.908 9.948C49.18 10.628 49.316 11.372 49.316 12.18C49.316 13.02 49.176 13.792 48.896 14.496C48.616 15.192 48.196 15.792 47.636 16.296C47.076 16.8 46.372 17.192 45.524 17.472C44.684 17.752 43.7 17.892 42.572 17.892H40.16V24H36.932V6.648H42.572ZM62.5554 14.904C63.1634 14.904 63.6914 14.828 64.1394 14.676C64.5954 14.524 64.9674 14.316 65.2554 14.052C65.5514 13.78 65.7714 13.46 65.9154 13.092C66.0594 12.724 66.1314 12.32 66.1314 11.88C66.1314 11 65.8394 10.324 65.2554 9.852C64.6794 9.38 63.7954 9.144 62.6034 9.144H60.5394V14.904H62.5554ZM70.8594 24H67.9434C67.3914 24 66.9914 23.784 66.7434 23.352L63.0954 17.796C62.9594 17.588 62.8074 17.44 62.6394 17.352C62.4794 17.264 62.2394 17.22 61.9194 17.22H60.5394V24H57.3114V6.648H62.6034C63.7794 6.648 64.7874 6.772 65.6274 7.02C66.4754 7.26 67.1674 7.6 67.7034 8.04C68.2474 8.48 68.6474 9.008 68.9034 9.624C69.1594 10.232 69.2874 10.904 69.2874 11.64C69.2874 12.224 69.1994 12.776 69.0234 13.296C68.8554 13.816 68.6074 14.288 68.2794 14.712C67.9594 15.136 67.5594 15.508 67.0794 15.828C66.6074 16.148 66.0674 16.4 65.4594 16.584C65.6674 16.704 65.8594 16.848 66.0354 17.016C66.2114 17.176 66.3714 17.368 66.5154 17.592L70.8594 24ZM94.5669 15.324C94.5669 16.596 94.3549 17.776 93.9309 18.864C93.5149 19.944 92.9229 20.88 92.1549 21.672C91.3869 22.464 90.4629 23.084 89.3829 23.532C88.3029 23.972 87.1029 24.192 85.7829 24.192C84.4709 24.192 83.2749 23.972 82.1949 23.532C81.1149 23.084 80.1869 22.464 79.4109 21.672C78.6429 20.88 78.0469 19.944 77.6229 18.864C77.1989 17.776 76.9869 16.596 76.9869 15.324C76.9869 14.052 77.1989 12.876 77.6229 11.796C78.0469 10.708 78.6429 9.768 79.4109 8.976C80.1869 8.184 81.1149 7.568 82.1949 7.128C83.2749 6.68 84.4709 6.456 85.7829 6.456C86.6629 6.456 87.4909 6.56 88.2669 6.768C89.0429 6.968 89.7549 7.256 90.4029 7.632C91.0509 8 91.6309 8.452 92.1429 8.988C92.6629 9.516 93.1029 10.108 93.4629 10.764C93.8229 11.42 94.0949 12.132 94.2789 12.9C94.4709 13.668 94.5669 14.476 94.5669 15.324ZM91.2669 15.324C91.2669 14.372 91.1389 13.52 90.8829 12.768C90.6269 12.008 90.2629 11.364 89.7909 10.836C89.3189 10.308 88.7429 9.904 88.0629 9.624C87.3909 9.344 86.6309 9.204 85.7829 9.204C84.9349 9.204 84.1709 9.344 83.4909 9.624C82.8189 9.904 82.2429 10.308 81.7629 10.836C81.2909 11.364 80.9269 12.008 80.6709 12.768C80.4149 13.52 80.2869 14.372 80.2869 15.324C80.2869 16.276 80.4149 17.132 80.6709 17.892C80.9269 18.644 81.2909 19.284 81.7629 19.812C82.2429 20.332 82.8189 20.732 83.4909 21.012C84.1709 21.292 84.9349 21.432 85.7829 21.432C86.6309 21.432 87.3909 21.292 88.0629 21.012C88.7429 20.732 89.3189 20.332 89.7909 19.812C90.2629 19.284 90.6269 18.644 90.8829 17.892C91.1389 17.132 91.2669 16.276 91.2669 15.324ZM108.562 15.372C109.154 15.372 109.67 15.3 110.11 15.156C110.55 15.004 110.914 14.792 111.202 14.52C111.498 14.24 111.718 13.904 111.862 13.512C112.006 13.112 112.078 12.668 112.078 12.18C112.078 11.716 112.006 11.296 111.862 10.92C111.718 10.544 111.502 10.224 111.214 9.96C110.926 9.696 110.562 9.496 110.122 9.36C109.682 9.216 109.162 9.144 108.562 9.144H106.15V15.372H108.562ZM108.562 6.648C109.722 6.648 110.726 6.784 111.574 7.056C112.422 7.328 113.122 7.708 113.674 8.196C114.226 8.684 114.634 9.268 114.898 9.948C115.17 10.628 115.306 11.372 115.306 12.18C115.306 13.02 115.166 13.792 114.886 14.496C114.606 15.192 114.186 15.792 113.626 16.296C113.066 16.8 112.362 17.192 111.514 17.472C110.674 17.752 109.69 17.892 108.562 17.892H106.15V24H102.922V6.648H108.562ZM126.541 9.216V14.028H132.613V16.512H126.541V21.42H134.245V24H123.301V6.648H134.245V9.216H126.541ZM152.79 21.336V24H142.626V6.648H145.854V21.336H152.79Z"
      fill={theme === HeaderTheme.Transparent ? '#FFFFFF' : '#00AEFF'}
    />
  </svg>
);

export enum HeaderVariant {
  Mobile = 'mobile',
  Desktop = 'desktop',
}
export enum HeaderTheme {
  White = 'white',
  Transparent = 'transparent',
}

const StickyRoutes = ['/account', '/pool-opportunities'];
const NonStickyAccountRoutes = ['/account/messages'];

const MobileHeader = ({
  user,
  location,
  theme,
  onLoginClick,
  onLogoutClick,
}): JSX.Element => {
  const [isOpen, setOpen] = useState(false);
  const proxy = useSelector(getProxy);
  return (
    <div className="z-10 h-16">
      <div className="relative flex items-center justify-center h-16">
        <div
          className={`text-2xl left-0 absolute flex items-center px-4 h-full ${
            theme === HeaderTheme.Transparent ? 'text-white' : 'text-blue-400'
          }`}
          onClick={() => setOpen(true)}
        >
          <MenuIcon fontSize="inherit" />
        </div>
        <div
          className="flex items-center justify-center h-10"
          onClick={() => animateScroll.scrollToTop()}
        >
          <SvgLogo theme={theme} />
        </div>
        {proxy && (
          <div className={`right-0 absolute flex items-center px-4 h-full `}>
            <div
              className={`badge ${
                theme === HeaderTheme.Transparent
                  ? 'bg-white text-blue-500'
                  : 'text-white bg-blue-400'
              }`}
            >
              Proxy
            </div>
          </div>
        )}
      </div>
      <SwipeableDrawer
        anchor={MobileDrawerSide}
        open={isOpen}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <div
          tabIndex={0}
          onClick={() => setOpen(false)}
          onKeyDown={() => setOpen(false)}
        >
          {!user ? (
            <GuestMenu
              pathname={location.pathname}
              theme={theme}
              variant={HeaderVariant.Mobile}
              onLoginClick={onLoginClick}
            />
          ) : (
            <LoggedInMenu
              user={user}
              pathname={location.pathname}
              theme={theme}
              variant={HeaderVariant.Mobile}
              onLogoutClick={onLogoutClick}
            />
          )}
        </div>
      </SwipeableDrawer>
    </div>
  );
};

const DesktopHeader = ({
  user,
  location,
  theme,
  onLoginClick,
  onLogoutClick,
}): JSX.Element => {
  return (
    <div className="z-10 flex items-center justify-between h-16">
      <div className="pl-4">
        <Link id="nav-home" to={APP_ROUTES.HOME}>
          <SvgLogo theme={theme} />
        </Link>
      </div>
      {!user ? (
        <GuestMenu
          pathname={location.pathname}
          theme={theme}
          variant={HeaderVariant.Desktop}
          onLoginClick={onLoginClick}
        />
      ) : (
        <LoggedInMenu
          user={user}
          pathname={location.pathname}
          theme={theme}
          variant={HeaderVariant.Desktop}
          onLogoutClick={onLogoutClick}
        />
      )}
    </div>
  );
};

const OpportunitiesHeader = ({ location, theme }): JSX.Element => {
  return (
    <div className="z-10 flex flex-col items-center justify-center px-4 py-2 gap-y-2 sm:justify-between sm:h-16 sm:flex-row">
      <div>
        <Link id="nav-home" to={APP_ROUTES.HOME}>
          <SvgLogo theme={theme} />
        </Link>
      </div>
      <OpportunitiesMenu theme={theme} pathname={location.pathname} />
    </div>
  );
};

const getTheme: (pathname: string) => HeaderTheme = (p) =>
  p === APP_ROUTES.HOME ||
  TRANSPARENT_HEADER_ROUTES.findIndex((r) => r === p) !== -1
    ? HeaderTheme.Transparent
    : HeaderTheme.White;

const Header = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [showLoginModal, setShowLogin] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const [theme, setTheme] = useState<HeaderTheme>(getTheme(location.pathname));
  const [opportunitiesHeader, setOpportunitiesHeader] = useState(false);
  const user = useSelector(getUser);
  const { enqueueSnackbar } = useSnackbar();

  const handleLoginClick = () => setShowLogin(true);
  const handleLogoutClick = () => {
    enqueueSnackbar(LogoutSuccessfulMessage);
    dispatch(logUserOut);
  };

  useEffect(() => {
    setSticky(
      StickyRoutes.some((r) => location.pathname.indexOf(r) === 0) &&
        !NonStickyAccountRoutes.some((r) => location.pathname.indexOf(r) === 0)
    );
    setOpportunitiesHeader(location.pathname.includes('/pool-opportunities'));
    setTheme(getTheme(location.pathname));
  }, [location.pathname]);

  return (
    <header
      id="ApplicationHeader"
      className={`${style.header} border-gray-400 ${
        !opportunitiesHeader ? 'h-16' : 'sm:h-16'
      } ${style[theme]}${isSticky ? ` ${style.sticky}` : ''}`}
    >
      {opportunitiesHeader ? (
        <OpportunitiesHeader location={location} theme={theme} />
      ) : (
        <>
          <Hidden smUp>
            <MobileHeader
              user={user}
              location={location}
              theme={theme}
              onLoginClick={handleLoginClick}
              onLogoutClick={handleLogoutClick}
            />
          </Hidden>
          <Hidden smDown>
            <DesktopHeader
              user={user}
              location={location}
              theme={theme}
              onLoginClick={handleLoginClick}
              onLogoutClick={handleLogoutClick}
            />
          </Hidden>
          <AuthenticationModal
            flow="HeaderFlow"
            initialForm="login"
            onClose={() => setShowLogin(false)}
            isOpen={showLoginModal}
          />
        </>
      )}
    </header>
  );
};

export default Header;
